import closeIcon from "../assets/images/icons/close-circle.svg";
import backArrow from "../assets/images/icons/arrow-left.svg";
import NotificationCard from "./NotificationCard";
import {useTranslation} from "react-i18next";
import * as NotificationsService from "../Modules/Notifications/Service/NotificationsService";
import {useEffect, useState} from "react";
import Loading from "./Loading";
import {useNavigate} from "react-router-dom";
import bellIcon from "../assets/images/icons/bell_zz.svg";

const NotificationMenu = ({openMenu, setOpenMenu}) => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [notifications, setNotifications] = useState([]);

    const getNotifications = async () => {
        setLoading(true);
        try {
            const res = await NotificationsService.notificationsList();
            setNotifications(res);
        } catch (err) {
            
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getNotifications();
    }, []);

    const getNotificationInfo = async (item) => {
        try {
            await NotificationsService.notificationsMarkedRead({
                notification_ids: [item.id],
            });
            navigate(`/profile/${item?.sender_profile}`);
        } catch (err) {
            
        } finally {
            setOpenMenu(false);
            setLoading(false);
        }
    };

    if (loading) {
        return <Loading/>;
    }

    return (
        <div className={openMenu ? "notificationMenu open" : "notificationMenu"}>
            <div className="top">
                <div className="backIcon" onClick={() => setOpenMenu(false)}>
                    <img src={backArrow} alt="back-arrow-icon"/>
                </div>
                <h4 className="topTitle">{t("notificationMenu.topTitle")}</h4>
                <div className="closeIcon" onClick={() => setOpenMenu(false)}>
                    <img src={closeIcon} alt="close-icon"/>
                </div>
            </div>
            <div className="bottom">
                {notifications?.map((item) => (
                    <NotificationCard
                        data={item}
                        onClickCard={(item) => getNotificationInfo(item)}
                        key={item.id}
                    />
                ))}
                {notifications.length === 0 && (
                    // <p style={{ textAlign: "center" }}>{t("notificationMenu.empty")}</p>
                    <div className="emptyNotification">
                        <img src={bellIcon} alt="bell-icon"/>
                    </div>
                )}
            </div>
        </div>
    );
};

export default NotificationMenu;
